<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    :title="title"
    show-close
    width="600px"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    v-el-dialog-drag
    append-to-body
  >
    <Main
      ref="main"
      :pdCostsOrderGoodsCode="pdCostsOrderGoodsCode"
      :pdCostsOrderGoodsOtherFeesCode="pdCostsOrderGoodsOtherFeesCode"
      :disabled="disabled"
      @reload="$emit('reload')"
      @close="close()"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="$refs.main.save()"
        v-if="!disabled"
      >
        {{ this.$l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    pdCostsOrderGoodsOtherFeesCode: { type: String, default: '' },
    pdCostsOrderGoodsCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
